var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHydroelectricOperation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3791_7549)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#00658C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9447 17.0594C20.5915 17.2289 20.1801 17.3334 19.6667 17.3334C18.8533 17.3334 18.3301 17.0883 17.9099 16.7821C17.7865 16.6922 17.6542 16.5823 17.5464 16.4927C17.501 16.4549 17.4599 16.4208 17.4256 16.3932C17.2893 16.2837 17.1736 16.2027 17.0455 16.1414C16.7134 15.9824 16.573 15.5843 16.732 15.2522C16.8909 14.9201 17.289 14.7797 17.6211 14.9387C17.8831 15.0641 18.0907 15.2172 18.2608 15.3539C18.3339 15.4126 18.3931 15.462 18.4465 15.5067C18.5329 15.5787 18.6043 15.6384 18.6951 15.7046C18.9199 15.8684 19.1734 16 19.6667 16C19.9866 16 20.2001 15.9378 20.3678 15.8573C20.5496 15.7701 20.7018 15.6515 20.9169 15.4794C20.9224 15.475 20.9281 15.4705 20.9337 15.4659C21.1332 15.3063 21.3923 15.0989 21.7219 14.9407C22.0751 14.7711 22.4866 14.6667 23 14.6667C23.5259 14.6667 23.9429 14.7694 24.2987 14.9416C24.6313 15.1025 24.885 15.314 25.0768 15.474C25.0824 15.4787 25.088 15.4833 25.0934 15.4879C25.3763 15.7236 25.4145 16.144 25.1788 16.4268C24.9431 16.7097 24.5227 16.7479 24.2399 16.5122C24.0336 16.3403 23.8923 16.2262 23.718 16.1418C23.5571 16.064 23.3408 16 23 16C22.6801 16 22.4665 16.0622 22.2989 16.1427C22.1171 16.23 21.9648 16.3486 21.7498 16.5206C21.7442 16.5251 21.7386 16.5296 21.7329 16.5341C21.5334 16.6938 21.2744 16.9011 20.9447 17.0594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9446 21.0594C20.5914 21.2289 20.18 21.3334 19.6666 21.3334C19.1507 21.3334 18.6686 21.2347 18.2704 21.0795C17.8938 20.9328 17.512 20.7037 17.2871 20.3823C17.0759 20.0807 17.1493 19.665 17.4509 19.4539C17.7526 19.2427 18.1682 19.3161 18.3794 19.6177C18.3792 19.6174 18.3792 19.6175 18.3796 19.6179C18.3826 19.6215 18.4069 19.6499 18.4706 19.6932C18.5382 19.739 18.633 19.7899 18.7544 19.8372C18.9979 19.932 19.3158 20 19.6666 20C19.9865 20 20.2 19.9378 20.3677 19.8573C20.5495 19.7701 20.7018 19.6515 20.9168 19.4794C20.9223 19.475 20.928 19.4705 20.9337 19.4659C21.1331 19.3063 21.3922 19.0989 21.7218 18.9407C22.075 18.7711 22.4865 18.6667 22.9999 18.6667C23.5258 18.6667 23.9428 18.7694 24.2986 18.9416C24.6312 19.1025 24.8849 19.314 25.0767 19.474C25.0823 19.4787 25.0879 19.4833 25.0933 19.4879C25.3762 19.7236 25.4144 20.144 25.1787 20.4268C24.943 20.7097 24.5226 20.7479 24.2398 20.5122C24.0335 20.3403 23.8922 20.2262 23.7179 20.1418C23.557 20.064 23.3407 20 22.9999 20C22.68 20 22.4664 20.0622 22.2988 20.1427C22.117 20.23 21.9647 20.3486 21.7497 20.5206C21.7441 20.5251 21.7385 20.5296 21.7328 20.5341C21.5333 20.6938 21.2743 20.9011 20.9446 21.0594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 14.6667C10.6667 14.2985 10.9652 14 11.3334 14H14.0001C14.3683 14 14.6667 14.2985 14.6667 14.6667C14.6667 15.0349 14.3683 15.3333 14.0001 15.3333H11.3334C10.9652 15.3333 10.6667 15.0349 10.6667 14.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 17.3334C10.6667 16.9652 10.9652 16.6667 11.3334 16.6667H14.0001C14.3683 16.6667 14.6667 16.9652 14.6667 17.3334C14.6667 17.7015 14.3683 18 14.0001 18H11.3334C10.9652 18 10.6667 17.7015 10.6667 17.3334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 20C10.6667 19.6318 10.9652 19.3333 11.3334 19.3333H14.0001C14.3683 19.3333 14.6667 19.6318 14.6667 20C14.6667 20.3682 14.3683 20.6666 14.0001 20.6666H11.3334C10.9652 20.6666 10.6667 20.3682 10.6667 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 12C10.6667 11.6318 10.9652 11.3333 11.3334 11.3333H14.0001C14.3683 11.3333 14.6667 11.6318 14.6667 12C14.6667 12.3682 14.3683 12.6666 14.0001 12.6666H11.3334C10.9652 12.6666 10.6667 12.3682 10.6667 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7238 9.72384C13.9738 9.47379 14.313 9.33331 14.6666 9.33331H15.9999C16.3535 9.33331 16.6927 9.47379 16.9427 9.72384C17.1813 9.96241 17.3201 10.2821 17.3324 10.6181L18.6614 21.2506C18.6649 21.2781 18.6666 21.3057 18.6666 21.3333C18.6666 21.6869 18.5261 22.0261 18.2761 22.2761C18.026 22.5262 17.6869 22.6666 17.3333 22.6666H14.6666C14.313 22.6666 13.9738 22.5262 13.7238 22.2761C13.4737 22.0261 13.3333 21.6869 13.3333 21.3333V10.6666C13.3333 10.313 13.4737 9.97389 13.7238 9.72384ZM15.9999 10.6666H14.6666L14.6666 21.3333H17.3281L16.0051 10.7493C16.0016 10.7219 15.9999 10.6943 15.9999 10.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3791_7549",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3791_7549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3791_7549",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydroelectricOperation);
export default __webpack_public_path__ + "static/media/hydroelectric_operation.b4974dbbdc6034b9c2ec063e06ce35d0.svg";
export { ForwardRef as ReactComponent };